import { environment } from "../environment";
import { AsyncResult } from "../models/common/async-result";
import { Forum } from "../models/forum";
import api from "./api";

export async function getClubForum(clubId: number): Promise<Forum | undefined> {
  const baseUrl = environment.api.forum.getClubForum
    .replace('{clubId}', String(clubId));
  
  const clubForum = await api.get(baseUrl).then(res => res.data.success);
  if (Object.keys(clubForum).length === 0) return undefined;
  return clubForum;
}

export async function getForumsByUser(userId: number): Promise<Forum[]> {
  const baseUrl = environment.api.forum.getByUser
    .replace('{userId}', String(userId));
  
  const forums = await api.get(baseUrl).then(res => res.data.success);
  return forums;
}

export async function createForum(payload: Forum, clubId: number, userId: number): Promise<AsyncResult<Forum>> {
  let baseUrl = environment.api.forum.create
    .replace('{clubId}', String(clubId))
    .replace('{userId}', String(userId));

  return await api.post(baseUrl, payload)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } });
}